import { render, staticRenderFns } from "./SystemGeneratedEmails.vue?vue&type=template&id=58942b0e&"
import script from "./SystemGeneratedEmails.vue?vue&type=script&lang=js&"
export * from "./SystemGeneratedEmails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports